/**
 * 供应商费用申诉
 */

// 协同查询其他违约金费用合同分页列表
export const API_POST_CONTRACT_COST_INCOME_LIST = {
  url: 'api/settle/contractCostIncome/selectFl04CostIncomeList',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 协同根据单据编号获取合同费用录入单详情信息
export const API_POST_CONTRACT_COST_INCOME_INFO_BY_BILLNO = {
  url: 'api/settle/contractCostIncome/infoByBillNo',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 审批列表-审批记录
export const API_POST_CONTRACT_AUDIT_LOG = {
  url: 'api/settle/contractCostIncome/queryContractAuditLog',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 协同根据单据编号发起申诉
export const API_POST_CONTRACT_COST_INCOME_INITIATE_APPEAL = {
  url: 'api/settle/contractCostIncome/initiateAnAppeal',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
